<template>
    <div class="modal fade" id="trialModal" tabindex="-1" role="dialog" aria-labelledby="trialModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered tw-w-1/2" role="document">
            <div class="tw-border tw-border-border-panel tw-rounded-lg tw-overflow-hidden tw-bg-white" style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.31);">
                <div class="tw-border-b tw-border-border-panel tw-p-4 tw-text-white tw-bg-white tw-py-2 tw-flex tw-justify-between">
                    <h4 class="tw-font-ssp_semibold tw-text-black tw-text-2xl">Termin eintragen</h4>
                    <button type="button" class="tw-text-xl tw-font-bold tw-leading-none tw-text-black tw-bg-opacity-25 tw-shadow-sm" data-dismiss="modal">&times;</button>
                </div>
                <div class="tw-py-4 tw-overflow-x-auto">
                    <div class="tw-px-4 tw-container">
                        <div class="tw-mb-2">
                            <div class="tw-flex">
                                <div class="tw-flex tw-mr-8">
                                    <radio
                                        id="modal_sex_male"
                                        name="modal_sex"
                                        initial-value="male"
                                        v-model="form.sex"
                                    ></radio>
                                    <label for="modal_sex_male">Herr</label>
                                </div>
                                <div class="tw-flex">
                                    <radio
                                        id="modal_sex_female"
                                        name="modal_sex"
                                        initial-value="female"
                                        v-model="form.sex"
                                    ></radio>
                                    <label for="modal_sex_female">Frau</label>
                                </div>
                            </div>
        
                            <div class="tw-w-full tw-text-danger-primary tw-text-sm tw-mb-2" v-if="errors.sex">
                                <span>{{ errors.sex }}</span>
                            </div>
                        </div>
        
                        <div class="tw-mb-2">
                            <div class="cu-input-simple">
                                <input type="text" name="from_email" id="modal_from_email" v-model="form.name">
                            </div>
        
                            <div class="tw-text-danger-primary tw-text-sm tw-mb-2" v-if="errors.name">
                                <span>{{ errors.name }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="tw-px-4 tw-container">
                        <div class="tw-flex tw-mr-8 tw-gap-3">
                            <div class="tw-flex tw-mb-1">
                                <radio
                                    id="trial_one_day"
                                    name="trial_type"
                                    initial-value="one_day"
                                    v-model="form.trial_type"
                                ></radio>
                                <label for="trial_one_day">eintägig</label>
                            </div>

                            <div class="tw-flex">
                                <radio
                                    id="trial_multi_day"
                                    name="trial_type"
                                    initial-value="multi_day"
                                    v-model="form.trial_type"
                                ></radio>
                                <label for="trial_multi_day">mehrtägig</label>
                            </div>
                        </div>
                    </div>

                    <div class="tw-px-4 tw-mb-2 tw-container">
                        <div class="tw-w-full tw-flex tw-my-2">
                          <div class="tw-w-full">
                            <bordered-input classes="tw-mr-4">
                                <template slot="label">
                                    <label for="modal_date_from">Datum Beginn</label>
                                </template>
                                <template slot="input">
                                    <input id="modal_date_from" type="date" v-model="form.date_from" @change="syncEndDate">
                                </template>
                            </bordered-input>
                            <div class="tw-text-danger-primary tw-text-sm" v-if="errors.date_from">{{ errors.date_from }}</div>
                          </div>
                          <div id="container_date_end" :class="{'tw-hidden': isOneDay}" class="tw-w-full tw-ml-1">
                                <bordered-input>
                                    <template slot="label">
                                        <label for="modal_date_end">Datum Ende</label>
                                    </template>
                                    <template slot="input">
                                        <input id="modal_date_end" type="date" v-model="form.date_end">
                                    </template>
                                </bordered-input>
                            <div class="tw-text-danger-primary tw-text-sm" v-if="errors.date_end">{{ errors.date_end }}</div>

                          </div>
                        </div>
                        <div id="container_times" class="tw-flex tw-w-1/3 tw-gap-2" :class="{'tw-hidden': !isOneDay}">
                          <div>
                            <bordered-input>
                                <template slot="label">
                                    <label for="modal_time_start">Beginn</label>
                                </template>
                                <template slot="input">
                                    <input type="text" id="modal_time_start" placeholder="HH:mm" v-model="form.time_start">
                                </template>
                            </bordered-input>
                            <div class="tw-text-danger-primary tw-text-sm" v-if="errors.time_start">{{ errors.time_start }}</div>
                          </div>
                          <div>
                            <bordered-input>
                                <template slot="label">
                                    <label for="modal_time_end">Ende</label>
                                </template>
                                <template slot="input">
                                    <input type="text" id="modal_time_end" placeholder="HH:mm" v-model="form.time_end">
                                </template>
                            </bordered-input>
                            <div class="tw-text-danger-primary tw-text-sm" v-if="errors.time_end">{{ errors.time_end }}</div>
                          </div>
                        </div>
                    </div>
                  <div class="tw-px-4 tw-container">
                    <div class="tw-flex tw-items-center tw-ml-auto tw-gap-2">
                      <check-box
                          id="is_internship"
                          name="is_internship"
                          v-model="form.is_internship"
                      />

                      <label for="is_internship" class="tw-cursor-pointer">
                        Praktikum
                      </label>

                    </div>
                  </div>
                </div>
                <div class="tw-border-t tw-border-border-panel tw-p-4 tw-flex tw-justify-between">
                    <button @click="triggerDateAction" class="cu-btn tw-mr-4" style="display: flex; align-items: center;">
                        <i class="fa fa-spinner fa-pulse tw-mr-1" v-show="isLoading"></i>
                        Speichern
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Radio from '../Radio.vue';
    import BorderedInput from '../BorderedInput.vue';
    import CheckBox from '../CheckBox.vue';

    export default {
        name: "TrialModal",
        components: {
            Radio,
            BorderedInput,
            CheckBox,
        },
        props: {
            mail: {
                required: true,
                type: Object
            },
            department: {
                required: true,
                type: Object
            },
            hasPermissionAllDepartments: {
                required: false,
                type: Boolean,
                default: false
            },
            isInvite: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        data() {
            const STATUS_INTERN = 24;
            const STATUS_USER_INVITED_INTERN = 25;

            return {
                isLoading: false,
                isInviteInternal: this.isInvite,
                form: {
                    name: this.mail.applicant ? this.mail.applicant.name : this.mail.from_name,
                    trial_type: 'one_day',
                    date_from: '',
                    date_end: '',
                    time_start: '',
                    time_end: '',
                    is_internship: this.mail.status === STATUS_INTERN || this.mail.status === STATUS_USER_INVITED_INTERN,
                },
                errors: {
                    sex: '',
                    name: '',
                    date_from: '',
                    date_end: '',
                    time_start: '',
                    time_end: ''
                }
            }
        },
        computed: {
            isOneDay() {
                return this.form.trial_type === 'one_day';
            }
        },
        created() {
            EventBus.$on('set-trial-modal-is-invite', (val) => {
                this.isInviteInternal = val;
            });
        },
        methods: {
            syncEndDate() {
                if (this.isOneDay) {
                    this.form.date_end = this.form.date_from;
                }
            },
            validate() {
                this.errors = {
                    sex: '',
                    name: '',
                    date_from: '',
                    date_end: '',
                    time_start: '',
                    time_end: ''
                };
                let hasError = false;

                if (!this.form.sex) {
                  this.errors.sex = 'Bitte wählen Sie eine Anrede aus';
                  hasError = true;
                }

                if (!this.form.name) {
                  this.errors.name = 'Name darf nicht leer sein';
                  hasError = true;
                } else if (!this.form.name.includes(' ')) {
                  this.errors.name = 'Der Name enthält kein Leerzeichen';
                  hasError = true;
                } else if (this.form.name[0] === this.form.name[0].toLowerCase()) {
                  this.errors.name = 'Der Name beginnt nicht mit einem Großbuchstaben!';
                  hasError = true;
                }
                if (this.isOneDay) {
                    if (this.isInviteInternal || (this.form.date_from || this.form.time_start || this.form.time_end)) {
                        if (!this.form.date_from) {
                            this.errors.date_from = 'Datum Beginn muss ausgefüllt sein';
                            hasError = true;
                        }
                        if (!this.form.time_start) {
                            this.errors.time_start = 'Beginn muss ausgefüllt sein';
                            hasError = true;
                        } else if (!this.isValidTime(this.form.time_start)) {
                            this.errors.time_start = 'Ungültiges Zeitformat (HH:mm)';
                            hasError = true;
                        }
                        if (!this.form.time_end) {
                            this.errors.time_end = 'Ende muss ausgefüllt sein';
                            hasError = true;
                        } else if (!this.isValidTime(this.form.time_end)) {
                            this.errors.time_end = 'Ungültiges Zeitformat (HH:mm)';
                            hasError = true;
                        }
                    }
                } else {
                    if (this.isInviteInternal || (this.form.date_from || this.form.date_end)) {
                        if (!this.form.date_from) {
                            this.errors.date_from = 'Datum Beginn muss ausgefüllt sein';
                            hasError = true;
                        }
                        if (!this.form.date_end) {
                            this.errors.date_end = 'Datum Ende muss ausgefüllt sein';
                            hasError = true;
                        }
                    }
                }

                return !hasError;
            },
            isValidTime(time) {
                if (!time || !time.includes(':')) return false;
                const parts = time.split(':');
                if (parts.length !== 2) return false;
                const hour = parseInt(parts[0]);
                const minute = parseInt(parts[1]);
                return !isNaN(hour) && !isNaN(minute);
            },
            triggerDateAction() {
                if (!this.validate()) return;

                this.isLoading = true;
                if (this.isOneDay) {
                    this.syncEndDate();
                }

                const actionType = this.form.is_internship ? 'invite intern' : 'invite trial work';
                
                let hourStart = null;
                let minuteStart = null;
                let hourEnds = null;
                let minuteEnds = null;

                if (this.isOneDay && this.form.time_start && this.form.time_end) {
                    const startParts = this.form.time_start.split(':');
                    hourStart = parseInt(startParts[0]);
                    minuteStart = parseInt(startParts[1]);

                    const endParts = this.form.time_end.split(':');
                    hourEnds = parseInt(endParts[0]);
                    minuteEnds = parseInt(endParts[1]);
                } else if (!this.isOneDay && this.form.date_from && this.form.date_end) {
                    hourStart = 0;
                    minuteStart = 0;
                    hourEnds = 0;
                    minuteEnds = 0;
                }

                const url = this.hasPermissionAllDepartments ? "/applications/inbox/all" : ( "/applications/inbox/" + this.department.id );

                axios.post('/application-department-action', {
                    action_type: actionType,
                    mail_id: this.mail.id,
                    current_department_id: this.department.id,
                    date_from: this.form.date_from,
                    date_end: this.form.date_end,
                    hour_start: hourStart,
                    minute_start: minuteStart,
                    hour_ends: hourEnds,
                    minute_ends: minuteEnds,
                    sex: this.form.sex,
                    name: this.form.name,
                    department: true,
                    is_internship: this.form.is_internship,
                }).then(response => {
                    this.isLoading = false;
                    $('#trialModal').modal('hide');
                    window.location.href = url;
                }).catch(error => {
                    this.isLoading = false;
                    if (error.response && error.response.data && error.response.data.errors) {
                        const backendErrors = error.response.data.errors;
                        Object.keys(backendErrors).forEach(key => {
                            if (key === 'hour_start' || key === 'minute_start') {
                                this.errors.time_start = backendErrors[key][0];
                            } else if (key === 'hour_ends' || key === 'minute_ends') {
                                this.errors.time_end = backendErrors[key][0];
                            } else if (this.errors.hasOwnProperty(key)) {
                                this.errors[key] = backendErrors[key][0];
                            }
                        });
                    } else {
                        console.error(error);
                    }
                });
            }
        },
        mounted() {
            $('#trialModal').on('hidden.bs.modal', () => {
                this.isInviteInternal = this.isInvite;
            });
        }
    }
</script>
